import React from 'react'
import Tooltip from './../Tooltip/Tooltip'
import { Info } from './../NewIcons'

const InfoLabel = ({ label, size, tooltipLabel, tooltipPos, spaced, className }) => {
  return (
    <span
      className={
        'info-label' +
        (size ? ' info-label--' + size : ' info-label--md') +
        (className ? ' ' + className : '') +
        (spaced ? ' info-label--spaced' : '')
      }
    >
      <span className="info-label__label">{label}</span>
      <span className="info-label__icon-wrap">
        <Tooltip pos={tooltipPos} label={tooltipLabel}>
          <Info />
        </Tooltip>
      </span>
    </span>
  )
}

export default InfoLabel
